import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=b5eead50&scoped=true"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=b5eead50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eead50",
  null
  
)

export default component.exports